/**
 * @module app.ext.mcg-informed
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AssessmentAttachmentWithLocalState } from "app/core/models/local-state-extensions";
import { ITasksConfig } from 'app/core/models/essette-interfaces';
import * as Core from 'app/core/models/essette-api';
import * as Mcg from 'app/ext/mcg-informed/interfaces';

@autoinject()
export class AssessmentContext {

    ////****************** Fields and Properties **************************************////

    public attachment: AssessmentAttachmentWithLocalState = {};
    public currentSession: Core.AssessmentSession = {};
    public taskConfig: ITasksConfig | null = null;
    public questionComponents: Mcg.IQuestionComponent[] = [];
    public selectedQuestionReferenceIds: string = '';
    public unsavedChanges: boolean = false;

    ////****************** Lifecycle ***********************************************////

    constructor(
        private readonly logger: AppLogger) {

        this.logger.source = this;
    }

    ////****************** Functions ***********************************************////

    public clear(): void {
        this.currentSession = {};
        this.attachment = {};
        this.taskConfig = null;
        this.questionComponents = [];
        this.selectedQuestionReferenceIds = '';
        this.unsavedChanges = false;
    }

}
